import { useEffect, useState, type ReactNode } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../lib/auth.js';
import { readReturnTo } from '../lib/returnTo.js';

/**
 * Where the OIDC (ADR-0017) or SAML (ADR-0018) handshake lands. The backend
 * already set the session cookie on its own redirect — the SPA never saw any
 * of that, so it just re-asks `GET /api/user` and moves on.
 */
export function AuthCallbackScreen(): ReactNode {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (params.get('error')) {
      setFailed(true);
      return;
    }

    void refresh().then(() => navigate(readReturnTo('/displays'), { replace: true }));
  }, [params, refresh, navigate]);

  if (!failed) {
    return (
      <div className="auth-wrap">
        <div className="card card-pad auth-card stack">
          <p className="muted">Signing you in…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-wrap">
      <div className="card card-pad auth-card stack">
        <p>Single sign-on failed.</p>
        <p className="muted small">
          The identity provider didn’t complete sign-in, or your account isn’t set up for it yet. Ask
          your administrator, or use a password if one is set up for your account.
        </p>
        <button className="btn primary" onClick={() => navigate('/login', { replace: true })}>
          Back to sign-in
        </button>
      </div>
    </div>
  );
}
